import React , {CSSProperties} from 'react';
import { Row, Col, Popover } from 'antd'; // Import Popover
import { ReactComponent as NewDesignRefresh } from '../../../../src/assets/images/svg/NewDesignRefresh.svg';
import './tag.less'; // Import the CSS file
import { useDispatch, useSelector } from 'react-redux';
import {
  setSelectedElapsedTimeRemarks,
  setShowSelectedTpaPrimaryFilter,
  setShowSelectedTpaSecondaryFilters,
  setTpaDeskSecondaryFilter,
  setTPANextStatus,
} from '../../../store/actions/inPatientAction';
import { TPA_BANNER_TEXT } from '../../constants/commonConstants';
import { RootState } from '../../../store';
import { checkPrimaryBucketSuffix } from '../../../utils/utility';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';

const BucketedDataCards = (props: any): any => {
  const { bucketedData, resetFilter, selectedTag } = props;
  const { isInitiateSettelmentBtnClicked, tpaNextStatus, filters } = useSelector(
    (state: RootState): any => state?.selectedInPatientDetail || {},
  );
  const dispatch = useDispatch();

  const handleCardClick = (key: string): any => {
    customGTMEvent({
      event: 'Selected TPA Primary Filter',
      selectedPrimaryBucket: key,
    });
    dispatch(setSelectedElapsedTimeRemarks([]));
     delete filters.elapsedTime; // deleting the elapsed filter from the filters object onchange of primary filter
    dispatch(setTPANextStatus(key));
    key === TPA_BANNER_TEXT.DRAFT_PENDING
      ? selectedTag(TPA_BANNER_TEXT.DRAFT)
      : selectedTag(key);
    dispatch(setTpaDeskSecondaryFilter([]));
    dispatch(setShowSelectedTpaSecondaryFilters([]));
  };

  const popoverContent = (
    <div>
      <div className="tpa-popover-header">
        {TPA_BANNER_TEXT.PA_UTILIZATION_PENDING_TOOL_TIP_TITLE}
      </div>
      <hr className="tpa-popover-hr-line" />
      <div className="tpa-popover-content">
        {TPA_BANNER_TEXT.PA_UTILIZATION_PENDING_TOOL_TIP_CONTENT}
      </div>
    </div>
  );

  return (
    <Row align="middle" className="m-top-12">
      <Col>
        <Row gutter={[8, 8]}>
          {Object?.keys(bucketedData)?.map((key: any): any => {
            const { title, totalCount, colorCode, blink, additionalText, backGroundColor } = bucketedData[key];
            const isSelected = tpaNextStatus === key;
            const handelPrimaryBucketSuffix = checkPrimaryBucketSuffix(additionalText);
            const cardContent = (
              <div
                onClick={(): any => handleCardClick(key)}
                className={`card-container ${isSelected ? 'selected' : ''} ${
                  blink ? 'blink' : ''
                }`}
                style={{
                  '--blink-color': colorCode,
                  '--blink-bg-color': backGroundColor,
                  borderColor: colorCode,
                  opacity:
                    tpaNextStatus && !isSelected && !isInitiateSettelmentBtnClicked
                      ? 0.5
                      : 1,
                } as CSSProperties}
              >
                <div className="card-content">
                  <div className={`card-title ${(blink && !handelPrimaryBucketSuffix)  ? 'blink' : {}}`}
                  >
                    {title}
                    {(blink) && <span className={ handelPrimaryBucketSuffix ? 'primaryBucketSuffix' : 'dod_gt_3'}>{additionalText}</span>}
                  </div>
                  <div className="card-count" style={{ color: colorCode }}>
                   {totalCount}
                  </div>
                </div>
              </div>
            );

            return (
              <Col key={key}>
                {(blink && !additionalText) ? (
                  <Popover content={popoverContent} placement="bottom">
                    {cardContent}
                  </Popover>
                ) : (
                  cardContent
                )}
              </Col>
            );
          })}
        </Row>
      </Col>
      <Col flex="none" className="new-reset-filter mouse-pointer">
          <NewDesignRefresh  onClick={(): any => {
            resetFilter();
            dispatch(setShowSelectedTpaPrimaryFilter(null));
            customGTMEvent({
              event: 'Clicked New Reset Filter',
            });
          }}/>
      </Col>
    </Row>
  );
};

export default BucketedDataCards;
